<section>
    <div class="bg">
      <div class="" style="padding:50px 0px">
        <h1>MATCH PLAY</h1>
        <p class="header-text">Match play is one of the main forms of competition in golf. It pits players one against another, rather than one against the field as in stroke play. Opponents compete to win individual holes, and the player who wins the most holes wins the match.</p>
        <p class="header-text">Here are a few explanation on the terminology used in match play.</p>
      
      </div>
    </div>
  </section>
  <section>
    <div>
      <h3>Match Play Formats</h3>
      <p>Match play can be play in Singles, Fourball, or Foursome</p>
      <ul>
        <li>Singles: Player vs Player - Simple</li>
        <li>Fourball: Two teams of two players face off using the Best ball of each team - Also known as Best Ball</li>
        <li>Foursome: Two teams of two players face off player the same ball alternating each shot - Also known as Alternate Shot</li>
      </ul>
      <p>No matter which format you play, it's always only 1 score against 1 score.</p>  
    </div>
    <div>
      <h3>Scoring Match Play</h3>
      <p>Each Hole gets gets scored like so</p>
      <ul>
        <li>1 UP - You won the hole</li>
        <li>1 DW - You lost the hole</li>
        <li>Halved - You tied the hole</li>
      </ul>
      <p>At the end you total all the points and the player/team with the most points wins the match.</p>

      <p>When you score match play you can be:</p>
      <ul>
        <li>All Square - Even</li>
        <li>x DW - You are losing by 'x'</li>
        <li>y UP - You are winning by 'y'</li>
        <li>Dormie - You are winning by how many holes are left (i.e. 2UP with 2 holes to play)</li>
        <li>2&1 - You are 2 UP/DW with only 1 hole to go, the match it over</li>
      </ul>
    </div>
    <div>
      <h3>A few things to be aware of</h3>
      In Match Play ...
      <ul>
        <li>each hole is a separate competition</li>
        <li>you can miss your tee time but as long as you make it by the second hole, you can play (you will start 1 DW)</li>
        <li>you are playing against your direct competition, you lose, you're out.</li>
        <li>your opponent can make you re-hit a shot, so make sure you don't play out of turn.</li>
        <li>you can concede a putt/hole.</li>
      </ul>
    </div>
  </section>